import { useTranslation } from 'react-i18next'
import type { SchoolDto } from '../../api/school'
import { tierLabel } from '../../utils/schoolFormatters'

/** Карточка с реквизитами школы (название, регион, тариф, лицензии и т.д.). */
export function SchoolInfo({ school }: { school: SchoolDto }) {
  const { t } = useTranslation()
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 mb-5 grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
      <SchoolField label={t('schoolInfo.name')} value={school.name} />
      <SchoolField label={t('schoolInfo.region')} value={school.region ?? '—'} />
      <SchoolField label={t('schoolInfo.address')} value={school.address ?? '—'} />
      <SchoolField label={t('schoolInfo.tier')} value={tierLabel(school.subscriptionTier)} />
      <SchoolField label={t('schoolInfo.licenses')} value={school.licenseCount.toString()} />
      <SchoolField label={t('schoolInfo.created')} value={new Date(school.createdAt).toLocaleDateString('ru')} />
    </div>
  )
}

function SchoolField({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="text-[11px] font-semibold uppercase tracking-wider text-gray-500">{label}</div>
      <div className="text-gray-900 mt-0.5 break-words">{value}</div>
    </div>
  )
}
